import React, { Fragment } from 'react';

import useOfficialsTrackingSystemLscBulkRecertifyContextView from './UseOfficialsTrackingSystemLscBulkRecertifyContextView';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import PageNotFound from '@usas/ui-web/components/PageNotFound';

const OfficialsTrackingSystemLscBulkRecertifyContextView = ({ children }) => {
  const {
    isLoading,
    isLoggedIn,
    onBackToSelectionClicked,
    selectOrgUnitState,
    personOrgRoleState
  } = useOfficialsTrackingSystemLscBulkRecertifyContextView();

  if (isLoading === true || isLoggedIn === false) {
    return (
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={true} />
    );
  }
  else if (selectOrgUnitState.orgUnitId === '') {
    return (
      <Fragment>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackToSelectionClicked}>
              <LeftArrowIcon />  Back to Selection
            </button>
          </div>
        </div>
        <div className="row usas-extra-bottom-margin">
          <div className="col-xs-12">
            <PageNotFound />
          </div>
        </div>
      </Fragment>)
  }

  const getOrgUnitParentName = (orgUnitId) => {
    const parentOrgUnitName = personOrgRoleState?.arrayData?.find(x => x.orgUnitId === orgUnitId)?.parentOrgUnitName || '';
    return parentOrgUnitName;
  };

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <button className={global.HeaderButton}>
            <Headings.H3
              className={[global.NoBottomMargin, 'col-xs-12'].join(' ')}
              excludeBar={true}>
              OTS LSC Bulk Re-Certify
            </Headings.H3>
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <hr className="usas-bar-turmeric" />
        </div>
      </div>
      {selectOrgUnitState?.showBackToSelection &&
        <div className="row">
          <div className="col-xs-12">
            <button className={global.BackToSearchButton}
              type="button"
              onClick={onBackToSelectionClicked}>
              <LeftArrowIcon />  Back to Selection
            </button>
          </div>
        </div>}
      <div className="row usas-extra-bottom-margin">
        <div className={["col-xs-12", global.HeaderText].join(' ')}>
          <p className={global.HeaderText}><strong>Editing:</strong> {getOrgUnitParentName(selectOrgUnitState?.orgUnitId)}{selectOrgUnitState.orgUnitName ? ' / ' + selectOrgUnitState.orgUnitName : ''}</p>
        </div>
      </div>
      {children}
    </Fragment>
  )
};

export default OfficialsTrackingSystemLscBulkRecertifyContextView;